import { useCallback, useEffect } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { useOptionsProvider } from '@frontend/call-intel-core';
import { useCallIntelFiltersContext } from '../../context/call-intel-filters.context';

const DEFAULT_SCHEDULING_OUTCOMES: CallIntelTypes.SchedulingOutcomeV2Enum[] = [];

export const useSchedulingOutcomeFilterData = () => {
  const { filterValues, updateFilterValues, updateFilterModified, isLoading } = useCallIntelFiltersContext();
  const { getOptions } = useOptionsProvider();

  useEffect(() => {
    updateFilterModified({ schedulingOutcomeV2s: !!filterValues.schedulingOutcomeV2s?.length });
  }, [filterValues.schedulingOutcomeV2s, updateFilterModified]);

  const onChange = useCallback(
    (value: CallIntelTypes.SchedulingOutcomeV2Enum[]) => {
      updateFilterValues({ schedulingOutcomeV2s: value });
    },
    [updateFilterValues]
  );

  return {
    schedulingOutcomeOptions: getOptions('schedulingOutcomeV2'),
    value: filterValues.schedulingOutcomeV2s || [],
    defaultValue: DEFAULT_SCHEDULING_OUTCOMES,
    isLoading,
    onChange,
  };
};
